import Api from '../../Api';

export const getInfosMinhaConta = () => (
  Api.get('minha-conta')
);

export const postDocumentos = () => (
  Api.post('cadastro/documentos')
);
